// src/lib/menage-duree-api.js — durée de ménage PAR DÉFAUT d'un logement.
//
// Passe par l'endpoint serveur `menage_duree_set` et non par une écriture
// directe : la valeur vit dans `fbz8-cfg`, que la RLS de `public.storage` refuse
// aux rôles terrain. C'est le serveur qui écrit, borné par trois gardes (voir
// api/admin-users.js) — ce client n'en porte aucune, et ne doit pas donner
// l'illusion du contraire.
//
// Après un succès, l'appelant DOIT invalider le cache du guichet
// (`invalidateLogInfo`) : sans ça, `menage_log_info` continue de servir
// l'ancienne durée pendant 60 s et la frise dessine des blocs à la mauvaise
// largeur — un écran qui montre un réglage périmé juste après l'avoir accepté.

import { supabase } from '../supabase'
import { invalidateLogInfo } from './menage-log-info-cache'

const ENDPOINT = '/api/admin-users?action=menage_duree_set'

/**
 * @param {string} logementId
 * @param {number|null} minutes  `null` = revenir au défaut du parent / produit.
 * @returns {Promise<{ok: boolean, dureeEffective: number|null, traceOk: boolean, erreur: string|null}>}
 */
export async function fixerDureeDefautLogement(logementId, minutes) {
  try {
    const { data: { session } } = await supabase.auth.getSession()
    const token = session?.access_token
    if (!token) return { ok: false, dureeEffective: null, traceOk: false, erreur: 'Session expirée.' }

    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ logement_id: logementId, minutes }),
    })
    const json = await res.json().catch(() => ({}))

    if (!res.ok) {
      // Le conflit de version a son propre message : il se résout en réessayant,
      // contrairement à un refus de périmètre.
      const erreur = json?.code === 'cfg_conflit_version'
        ? 'La configuration a changé entre-temps. Réessayez.'
        : (json?.error || `Erreur ${res.status}`)
      return { ok: false, dureeEffective: null, traceOk: false, erreur }
    }

    invalidateLogInfo(logementId)
    return {
      ok: true,
      dureeEffective: typeof json?.menage_duree_min === 'number' ? json.menage_duree_min : null,
      traceOk: json?.trace_ok !== false,
      erreur: null,
    }
  } catch (e) {
    console.error('[duree-defaut]', e?.message || e)
    return { ok: false, dureeEffective: null, traceOk: false, erreur: 'Connexion impossible. Réessayez.' }
  }
}
